import { Controller } from "@hotwired/stimulus"

// Shows a formatted number (e.g. "$10,000.00") while the input is at rest and
// swaps in the raw editable number on focus. An edited value is left as typed
// so the enclosing form submits it; the server re-renders it formatted.
export default class extends Controller {
  static values = {
    formatted: String,
    raw: String,
  }

  blur = () => {
    if (this.element.value === this.rawValue) this.element.value = this.formattedValue
  }

  focus = () => {
    if (this.element.value === this.formattedValue) this.element.value = this.rawValue
  }
}
